// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"a19e5efe","284":"61378799","525":"2225df22","677":"8f61fc73","685":"c459686c","813":"1752fe8e"}[chunkId] + ".chunk.js";
};